import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import { GlobalStyle } from '../../global/global';
import { Box, Text } from '@chakra-ui/react';
import TilesSection from '../../sections/TilesSection/TilesSection';
import PromoBar from '../../sections/PromoBar/PromoBar';
import ContactSection from '../../sections/ContactSection/ContactSection';
import PlainSection from '../../sections/PlainSection/PlainSection';

interface Props {}

const image = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=324661&ext=.jpg',
    alt: 'Zdjęcie wyróżniające w hero - strona POS',
};

export default function PosPageEn(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Stationary sales and e&#8209;commerce in one place"
                subTitle="Integrate your online and stationary store into one modern POS checkout system. Increase sales and freely manage orders from both channels"
                image={image}
                type="landing"
            />
            <div className="homepage containerIdosellPages">
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={{ base: 'column', xl: 'row' }}
                    gap={{
                        base: 6,
                        md: 12,
                    }}
                    position={'relative'}
                >
                    <TilesSection
                        title={'Why should you choose our POS system?'}
                        // layout="2x3"
                        tiles={[
                            {
                                title: 'Full integration with e-commerce',
                                content:
                                    'POS Checkout System from IdoSell means full integration of a stationary store with an online one, and consistency of pricing across online and offline sales.',
                            },
                            {
                                title: 'Better customer service',
                                content:
                                    'Personalize offers and service to your customers with advanced tools. Plus, with automatic updates, your inventory will always be in sync.',
                            },
                            {
                                title: 'Consistent promotions and special offers',
                                content:
                                    'POS guarantees full support for the new IdoSell promotion module, special offers and free goods.',
                            },
                        ]}
                    />
                </Box>
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={{ base: 'column', xl: 'row' }}
                    gap={{
                        base: 6,
                        md: 12,
                    }}
                    position={'relative'}
                >
                    <PlainSection
                        layout="2/3"
                        title="What is a POS system?"
                        imageSide="left"
                        image={{
                            url: 'https://www.idosell.com/panel/file-gate.php?id=324662&ext=.jpg',
                            alt: 'Zdjęcie wyróżniające w hero - strona POS',
                        }}
                        text={
                            <>
                                <Text mb={'1rem'}>
                                    The POS system from IdoSell is a state-of-the-art POS solution
                                    that allows you to make sales in both stationary and online
                                    stores. Our POS system is distinguished by full integration of
                                    sales channels, or omnichannel. This means that all transactions
                                    are automatically synchronized between the stationary store and
                                    the online store.
                                </Text>
                                <Text>
                                    With omnichannel, your customers can shop at their convenience,
                                    and you can manage your business in one place, saving time and
                                    increasing efficiency.
                                </Text>
                            </>
                        }
                    ></PlainSection>
                </Box>
                <PromoBar
                    eyebrow="Ready to get started?"
                    title="Use our POS system for free for 30 days!"
                    version="green"
                    buttonText="Start Now"
                    href="#"
                />
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={{ base: 'column', xl: 'row' }}
                    gap={{
                        base: 6,
                        md: 12,
                    }}
                    position={'relative'}
                >
                    <TilesSection
                        title={
                            'POS checkout system from IdoSell - full integration of online and offline sales'
                        }
                        layoutDesktop="4-in-row"
                        tiles={[
                            {
                                title: 'Automatic inventory updates',
                            },
                            {
                                title: 'Advanced analytical tools',
                            },
                            {
                                title: 'Operation of payment terminals and fiscal receipts',
                            },
                            {
                                title: 'Ability to apply discounts, promotions and special offers from the e-store',
                            },
                            {
                                title: 'Handling personal pick-ups (click & collect) and returns of goods',
                            },
                            {
                                title: 'Cash reports, list of goods sold + list of documents issued',
                            },
                            {
                                title: 'Management of vouchers, gift and loyalty cards',
                            },
                            {
                                title: 'Complimentary goods',
                            },
                        ]}
                    />
                </Box>
                <ContactSection version="en" pb={1} mb={14} />
            </div>
        </ThemeProvider>
    );
}
